import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwSegmentedControlComponent } from './pw-segmented-control.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PwSegmentedControlComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    PwSegmentedControlComponent
  ]
})
export class PwSegmentedControlModule { }
